// Redux/Constants/SavedCardConstants.js
export const SAVED_CARD_FETCH_REQUEST = 'SAVED_CARD_FETCH_REQUEST';
export const SAVED_CARD_FETCH_SUCCESS = 'SAVED_CARD_FETCH_SUCCESS';
export const SAVED_CARD_FETCH_FAIL    = 'SAVED_CARD_FETCH_FAIL';

export const SAVED_CARD_DELETE_REQUEST = 'SAVED_CARD_DELETE_REQUEST';
export const SAVED_CARD_DELETE_SUCCESS = 'SAVED_CARD_DELETE_SUCCESS';
export const SAVED_CARD_DELETE_FAIL    = 'SAVED_CARD_DELETE_FAIL';

export const SAVED_CARD_CLEAR = 'SAVED_CARD_CLEAR';